<template>
  <div class="yunxiao parent-infos edit full-page" data-test="personal-info-edit">
    <van-form onSubmit="changeSubmit" class="full-page" ref="from" validate-first :show-error="false" :show-error-message="false">
      <van-field
        v-if="$route.query.propName && $route.query.propName === 'name'"
        v-model="username"
        clearable
        name="name"
        placeholder="姓名"
        maxlength="20"
        :formatter="(v) => v.trimLeft()"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="phone"
        name="phone"
        clearable
        type="tel"
        maxlength="11"
        :formatter="(v)=>v.replace(/[^0-9]/g, '')"
        placeholder="请输入手机号码"        
        v-if="$route.query.propName && $route.query.propName === 'phone'"
        :rules="[{ pattern: /^\d{11}$/, message: '请输入正确的手机号码' }]"/>
    </van-form>
    <page-footer-btn multipleBtns class="absolute-l-b">
      <van-button square round block type="primary" @click="changeSubmit"  data-test="personal-info-edit-btn-confirm">
        确定
      </van-button>
    </page-footer-btn>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";

export default {
  name: 'StudentInfosEdit',
  data: () => ({
    pageTitle: '修改个人信息',
    username: '',
    phone: '', 
  }),
  methods:{
    changeSubmit () {
      this.$refs.from.validate()
      .then(res=> {
        let { query } = this.$route;
        if (query.propName && query.propName === 'name') {
          app.vue.$emit('personalInfoChangeName', this.username.trim())
        }
        if (query.propName && query.propName === 'phone') {
          app.vue.$emit('personalInfoChangePhone', this.phone)
        }
        this.$router.back();
      })
      .catch((err)=>{
          if (err[0].message) this.$toast(err[0].message);
          if (err[0].name)  this.$refs.form &&  
                            this.$refs.form.$el && 
                            this.$refs.form.$el[err[0].name] && 
                            this.$refs.form.$el[err[0].name].focus();
      })
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler (v) {
        if (v.propName === 'name' && v.val) this.username = v.val;
        if (v.propName === 'phone' && v.val) this.phone = v.val;
      }
    }
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss">
.yunxiao.parent-infos.edit{
  .page-footer{
    display: flex;
    >button.delete{
      margin-right: 12px;
    }
  }
}
</style>